import { _js } from '@ifixit/utils/localize';
import { FaIcon } from '@ifixit/ui/components/icon';

/** A source and target language, each as a code and a display name. */
export type LanguagePair = {
   from: string;
   fromName: string;
   to: string;
   toName: string;
};

/** Codes, not names: the pair repeats down a narrow column. The sr-only
 *  sentence spells both out. */
export function LanguagePairChips({ pair }: { pair: LanguagePair }) {
   return (
      <span className="mt-0.5 flex items-center gap-1 text-xs text-gray-500">
         {/* Translators: %1 -> source language; %2 -> target language; */}
         <span className="sr-only">
            {_js('Source language %1, target language %2', pair.fromName, pair.toName)}
         </span>
         <span
            aria-hidden="true"
            className="rounded-sm border border-gray-200 px-1 py-px font-medium uppercase"
         >
            {pair.from}
         </span>
         <FaIcon name="arrow-right" className="size-2.5 fill-current" aria-hidden />
         <span
            aria-hidden="true"
            className="rounded-sm border border-gray-200 px-1 py-px font-medium uppercase"
         >
            {pair.to}
         </span>
      </span>
   );
}
